// API Reference: https://www.wix.com/corvid/reference
// “Hello, World!” Example: https://www.wix.com/corvid/hello-world

$w.onReady(function() {
    // Write your JavaScript here
    // To select an element by ID use: $w("#elementID")
    $w("#productPage1").getProduct()
        .then((product) => {
            $w('#CustomElement1').setAttribute(
                "price", (parseFloat(product.price) / 40).toFixed(2)
            );
        });
    // Click "Preview" to run your code
});